module.exports = __webpack_public_path__ + "static/media/Mercedes-Benz2.a47cb796.mp3";